import api from "../../../api";


export function transferCount(){
    return api.get("get-transfer-customers-count");
}